import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import styles from './HomePage.module.scss';
import classNames from "classnames";
import ArrowLeftIcon from '../../assets/box-arrow-left.svg';
import ListMessages from "./ListMessage";
import { outChat } from "../../store/slices/setChatIDSlice";
import ChatMenu from "./ChatMenu";
import MessageInputField from "./MessageInputField";
import ShowNameChat from "./ShowNameChat";
import { closeBar } from "../../store/slices/appSlice";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import CallIcon from '../../assets/telephone-fill.svg';
import { openModalCalls } from "../../store/slices/callsSlice";
import { clickType } from "../../constants/constants";
const SubscribersComponent = () => {
    const subscribers = useAppSelector(state => { var _a; return (_a = state.app.selectedChannel) === null || _a === void 0 ? void 0 : _a.listOfSubscribers; });
    const { t } = useTypedTranslation();
    return (_jsxs("span", { className: styles.subscribers, children: [t('subscribers'), ":  ", _jsx("span", { style: { fontWeight: 500 }, children: (subscribers === null || subscribers === void 0 ? void 0 : subscribers.length) || 0 })] }));
};
const OnlineStatusComponent = () => {
    const status = useAppSelector(state => state.app.onlineStatusSelectedUser);
    const isSelectedMessages = useAppSelector(state => state.app.selectedMessages);
    const { t } = useTypedTranslation();
    if (isSelectedMessages === null || isSelectedMessages === void 0 ? void 0 : isSelectedMessages.length)
        return null;
    if (status === null || status === void 0 ? void 0 : status.isOnline)
        return (_jsx("span", { className: styles.subscribers, children: _jsx("span", { style: { fontWeight: 500 }, children: t('online') }) }));
    return (_jsxs("span", { className: styles.subscribers, children: [t('wasOnline'), ":  ", _jsx("span", { style: { fontWeight: 500 }, children: status === null || status === void 0 ? void 0 : status.formatted })] }));
};
const CallButton = ({ isChannel, callerUid }) => {
    const isShowCheckbox = useAppSelector(state => state.app.showCheckbox);
    const isOpen = useAppSelector(state => state.calls.isOpen);
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    const caller = useAppSelector(state => state.app.currentUser);
    const callee = useAppSelector(state => state.app.selectedChat);
    const dispatch = useAppDispatch();
    const startCall = () => {
        dispatch(openModalCalls({
            mode: null,
            callerUid,
            roomId: null,
            callInfo: { caller, callee }
        }));
    };
    if (isOpen || isShowCheckbox || isChannel || isFavorites)
        return null;
    return (_jsx("div", { className: styles.contentHeader__callButton, children: _jsx("div", { className: styles.item, children: _jsx("button", { onClick: startCall, children: _jsx(CallIcon, { fontSize: '1rem' }) }) }) }));
};
const HeaderChat = ({ selectedChat }) => {
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    const dispatch = useAppDispatch();
    const { t } = useTypedTranslation();
    const closeChat = () => {
        dispatch(outChat());
    };
    const isChannel = !!(selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel);
    const menuIsOpen = useAppSelector(state => !!state.app.menu.menuChild);
    const handleClick = () => {
        if (isChannel)
            dispatch(closeBar(clickType.SHOW_CHANNEL_INFO));
        else if (isFavorites)
            return;
        else
            dispatch(closeBar(clickType.SHOW_USER_INFO));
    };
    useEffect(() => {
        window.history.pushState({ page: "custom" }, "", "");
        const listener = (event) => {
            if (!menuIsOpen) {
                closeChat();
                window.history.pushState({ page: "custom" }, "", "");
            }
        };
        window.addEventListener("popstate", listener);
        return () => window.removeEventListener("popstate", listener);
    }, [menuIsOpen]); //временный костыль. ПЕРЕПИСАТЬ !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!1
    return (_jsxs("header", { children: [_jsx("div", { className: styles.closeIcon, onClick: closeChat, children: _jsx(ArrowLeftIcon, { cursor: 'pointer' }) }), _jsxs("div", { className: styles.contentHeader, children: [_jsxs("div", { className: styles.contentHeader__selectedChat, children: [_jsx("span", { onClick: handleClick, style: { cursor: 'pointer' }, children: !isFavorites ?
                                    _jsx(ShowNameChat, {})
                                    :
                                        t('favorites') }), (selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel) ?
                                _jsx(SubscribersComponent, {})
                                :
                                    isFavorites ? null : _jsx(OnlineStatusComponent, {})] }), _jsx(CallButton, { isChannel: isChannel, callerUid: selectedChat.uid }), _jsx(ChatMenu, { selectedChat: selectedChat })] })] }));
};
const ChatContent = () => {
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const { t } = useTypedTranslation();
    if (!selectedChat) {
        return (_jsx("div", { className: classNames(styles.contentContainer, { [styles.notSelected]: !selectedChat }), children: _jsxs("span", { children: [t('selectChat'), "..."] }) }));
    }
    console.log('chat content render');
    return (_jsxs("div", { className: classNames(styles.contentContainer, { [styles.showContent]: selectedChat }), children: [_jsx("div", { className: styles.header, children: _jsx(HeaderChat, { selectedChat: selectedChat }) }), _jsx("div", { className: styles.chatWindow, children: _jsxs("main", { children: [_jsx(ListMessages, {}), _jsx(MessageInputField, { selectedChat: selectedChat })] }) })] }));
};
export default ChatContent;
